module.exports = __webpack_public_path__ + "img/TextoHeader.4ef6aca8.png";